<h2 mat-dialog-title><mat-icon color="warn">warning</mat-icon> {{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>

  @if (data.details && data.details.length > 0) {
    <ul>
      @for (detail of data.details; track detail) {
        <li class="font-mono">{{ detail }}</li>
      }
    </ul>
  }

  @if (data.eventId) {
    <p>
      Event ID for Support: {{ data.eventId }}
      <button type="button" mat-icon-button (click)="copyEventId()">
        <mat-icon>content_copy</mat-icon>
      </button>
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions>
    <button
      type="button"
      mat-raised-button
      [mat-dialog-close]="false"
      cdkFocusInitial
    >OK</button>
</mat-dialog-actions>
